import { render, staticRenderFns } from "./SlDialog.vue?vue&type=template&id=6537e6d4&"
import script from "./SlDialog.vue?vue&type=script&lang=js&"
export * from "./SlDialog.vue?vue&type=script&lang=js&"
import style0 from "./SlDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports